var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"color":"primary","dark":"","flat":"","fixed":""}},[_c('v-icon',{on:{"click":_vm.Back}},[_vm._v("home")]),_c('v-spacer'),_vm._v(" "+_vm._s(_vm.app_title)+" "),_c('v-spacer'),_c('v-avatar',{attrs:{"size":"50"}},[_c('img',{attrs:{"src":_vm.app_avatar,"alt":_vm.app_avatar}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }